"use client";

import { useEffect, useState } from "react";
import { State } from "../../models/gameModels.ts";
import Typography from "antd/lib/typography";
import { useInterval } from "../../utils/useInterval.ts";
import { formatSeconds } from "../../services/timer.ts";
import { TIMER_STORAGE_KEY } from "../../services/timer.ts";
import { getTimer } from "../../services/timer.ts";
import { TimeState } from "../../services/timer.ts";

let focus = false;

const gameOver = (state: State) => {
  return state?.incomplete?.length <= 1 || state?.mistakesRemaining === 0;
};

const GameTimer = ({ game, showing }: { game: State; showing: boolean }) => {
  let initialState: TimeState = { seconds: 0, date: game?.initialPuzzle?.dt };
  const cachedTime = getTimer();
  if (cachedTime) {
    initialState = cachedTime;
  }
  const [{ seconds, date }, setSeconds] = useState<TimeState>(initialState);
  if (date !== game?.initialPuzzle?.dt) {
    setSeconds({ seconds: 0, date: game?.initialPuzzle?.dt });
  }
  // User has switched back to the tab
  const onFocus = () => {
    focus = true;
  };

  const onBlur = () => {
    focus = false;
  };

  useInterval(() => {
    if (focus && !gameOver(game)) {
      const state: TimeState = { seconds: seconds + 1, date };
      setSeconds(state);
      localStorage.setItem(TIMER_STORAGE_KEY, JSON.stringify(state));
    }
  }, 1000);

  useEffect(() => {
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", onBlur);
    // Calls onFocus when the window first loads
    onFocus();
    // Specify how to clean up after this effect:
    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  return (
    <Typography.Text
      style={{
        fontWeight: "bold",
        fontFamily: "Open Sans",
        textAlign: "center",
        padding: "2vh",
        display: showing ? "block" : "none",
      }}
    >
      {formatSeconds(seconds)}
    </Typography.Text>
  );
};

export default GameTimer;
